/**
 * Anel no chão sob cada atleta (item 4.4, GDD seção 5): mostra onde o atleta está no campo, junto com a sombra,
 * e fica mais fechado e forte quanto mais baixo ele voa. O seu é dourado; os outros, na cor do time.
 */
import * as THREE from "three";
import { ATHLETE_VIEW_SCALE, FLIGHT, PITCH } from "@besenliga/shared";
import type { Team } from "@besenliga/sim";

const COLORS = {
  casa: new THREE.Color(0x1f8a8a),
  fora: new THREE.Color(0xc23b3b),
  mine: new THREE.Color(0xf2a541),
};

export interface RingTarget {
  position: THREE.Vector3;
  team: Team;
  mine: boolean;
}

/** Raio do anel (m) pela altura: largo no alto, justo perto do chão. */
export function ringRadius(height: number): number {
  const t = THREE.MathUtils.clamp((height - FLIGHT.minHeight) / (PITCH.ceiling - FLIGHT.minHeight), 0, 1);
  return (0.55 + 0.6 * t) * ATHLETE_VIEW_SCALE;
}

export class HeightRings {
  readonly mesh: THREE.InstancedMesh;
  private readonly m = new THREE.Matrix4();

  constructor(count: number) {
    const geo = new THREE.RingGeometry(0.86, 1, 40);
    geo.rotateX(-Math.PI / 2);
    this.mesh = new THREE.InstancedMesh(
      geo,
      new THREE.MeshBasicMaterial({ transparent: true, opacity: 0.75, depthWrite: false }),
      count,
    );
    this.mesh.name = "Aneis_altura";
    this.mesh.frustumCulled = false;
    this.mesh.renderOrder = 2;
    this.mesh.count = 0;
  }

  update(targets: readonly RingTarget[]): void {
    targets.forEach((t, i) => {
      const r = ringRadius(t.position.y) * (t.mine ? 1.15 : 1);
      this.m.makeScale(r, 1, r).setPosition(t.position.x, 0.06, t.position.z);
      this.mesh.setMatrixAt(i, this.m);
      this.mesh.setColorAt(i, t.mine ? COLORS.mine : COLORS[t.team]);
    });
    this.mesh.count = targets.length;
    this.mesh.instanceMatrix.needsUpdate = true;
    if (this.mesh.instanceColor) this.mesh.instanceColor.needsUpdate = true;
  }

  dispose(): void {
    this.mesh.geometry.dispose();
    (this.mesh.material as THREE.Material).dispose();
    this.mesh.removeFromParent();
  }
}
